import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { Adresse, AuftragsFormular, AuftragsKomponente, Kontakt } from 'src/app/api/model/swagger-model';
import { SystemService } from 'src/app/api/system.service';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

const log = new Logger("AuftragAdresseComponent");

@Component({
    selector: 'auftrag-adresse-komponente',
    templateUrl: 'adresse-komponente.component.html',
    styleUrls: ['./adresse-komponente.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragAdresseComponent extends KomponenteBase implements OnInit, OnChanges {

    @ViewChild('map', { static: false }) mapDiv: ElementRef;

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;
    @Input() adresse: Adresse;

    mapAnzeigen = false;
    mapHeight = '200px';
    opacity = '1.0';
    nummerAnzeigen = false;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
        this.init();
    }

    init() {
        this.mapAnzeigen = this.getEinstellung('MapAnzeigen', 'nein') === 'ja'
        this.mapHeight = this.getEinstellung('MapHeight', '200px');
        this.opacity = this.getEinstellung('Opacity', '1.0')
        this.nummerAnzeigen = this.getEinstellung('Nummer') === 'ja';

        if (this.mapAnzeigen) {
            // Wenn keine Geokoordinaten vorhanden sein, dann kann die Karte nicht angezeigt werden
            let geoAdresseVorhanden = (this.adresse.GeoX && this.adresse.GeoY) || (this.adresse.GeocodingLatitude && this.adresse.GeocodingLongitude);

            if (!geoAdresseVorhanden) {
                log.warn('Adresse hat keine Geokoordinaten. Karte kann nicht angezeigt werden');
                this.mapAnzeigen = false;
            }
        }

        this.cdr.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        this.init();
    }

    async onNavigationStarten() {
        log?.debug('onNavigationStarten');
        this.auftragdetails.starteNavigation(this.adresse);
    }

    async onAnrufen() {
        log?.debug('onAnrufen');
        this.auftragdetails.anrufen(this.adresse);
    }

    async onAdresseClicked() {
        log?.debug('onAdresseClicked', this.adresse);

        if (this.auftrag.IstNeuanlage) {
            this.onAdresseAendern();
            return;
        }

        const result = await this.auftragdetails.frageAdresseAktion(this.komponente, this.adresse);

        if (result && result.aktion) {
            switch (result.aktion) {
                case 'Anrufen':
                    const kontakt = result.data as Kontakt;
                    SystemService.instance.anrufenTelefonnummer(kontakt.Telefon);
                    break;

                case 'navigation':
                    this.starteNavigation();
                    break;

                case 'adresse-aendern':
                    this.onAdresseAendern();
                    break;
            }
        }
    }

    private async starteNavigation() {
        this.auftragdetails.starteNavigation(this.adresse);
    }

    onAdresseAendern() {
        this.auftragdetails.anzeigenAdresseAendern(this.adresse);
    }

    onTexteAusblenden() {
        log?.debug('onTexteAusblenden');

        this.auftrag.texteAusgeblendet = true;
    }

    onTexteEinblenden() {
        log?.debug('onTexteEinblenden');

        this.auftrag.texteAusgeblendet = false;
    }
}
